import React from 'react';

import './ContentWithSidebar.scss';

interface Props {
  children?: React.ReactNode;
  sidebar?: React.ReactNode;
}

const ContentWithSidebar: React.FC<Props> = ({ children, sidebar }) => {
  return (
    <div className={'contentWithSidebar'}>
      <div className="content">{children}</div>
      <div className="sidebar">{sidebar}</div>
    </div>
  );
};

export default ContentWithSidebar;
